import { useState, useEffect } from "react";
import {getPuestoTrabajo, updatePuestoTrabajo} from "../../services/puestotrabajo";
import { getModuloUsuario } from "../../services/modulos";
import { ErrorContext } from "../../utils/context/error";
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import Modal from "../modal";

function WorkPlaces({show, handleshow}) {
  const [areaId, setAreaId] = useState(0);
  const [moduloId, setModuloId] = useState(0);
  
  const [areas, setAreas] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [validar, setValidar] = useState(false);
  const [habilita, setHabilita] = useState(false);
  const { setShowToast, setOpciones } = ErrorContext();
  const navigate = useNavigate()
  /**
   *  Boton Aceptar
  */
  const handleLogin = async () => {
     setHabilita(true);

    if (areaId !== "" && moduloId !=="") {
      const Data = {
        areaId,
        moduloId,
      };
  /**
   * 
   */
      const response = await updatePuestoTrabajo(Data);
      if (response) 
      {
        if (response.status === 200) {
            handleshow(false);
            setValidar(false);
            // refresh
            navigate(0)
        } else {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
        }
      }
    }
      setHabilita(false);
  };
  //-----
  const handleCancel = async () => 
    {
      handleshow(false);
    };
  
  //--- Trae todas las Areas 
  const fillPuestoTrab = async () => 
    {
      const response = await getPuestoTrabajo();
      if (response) 
        {
           if (response.status === 200) 
            {
               setAreas(response.data.area);
               setAreaId(response.data.data[0]?.AreaId);
               setModuloId(response.data.data[0]?.ModuloId);
            } 
           else 
           {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
           }
        }
    };
  /**
  * Modulos del area y del usuario 
  */
  const fillModulos =  async () => 
    {
      setShowToast(false);
      const response = await getModuloUsuario(areaId);
      if (response)
      {
         if (response.status === 200) 
            setModulos(response.data.data);
         else 
         {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
         }
      }   
      else 
       {
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
       }      
    };

  const handlearea =(area) =>{
    setModuloId(0);
    setAreaId(area);
  } 

  useEffect(() => {
    fillPuestoTrab();
  }, []);

  useEffect(() => {
  if (areaId > 0 ) {
      fillModulos(areaId);
    }
  }, [areaId]);

  return (
    <>
     <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Puesto de Trabajo'}>
      <div className="flex w-full h-full">
         <form noValidate>
            <div className="w-full">
               <label>Area</label>
               <select id="area" name="area" value={areaId || 0} onChange={(e) => handlearea(Number(e.target.value))} label="Area"  className={`${validar && areaId === 0 ? `border-red-500 focus:border-red-500 focus:red-500`: ""}`}>
                 <option value={0} disabled>
                    Seleccionar una Area...
                  </option>
                  {areas.map((item) => {
                     return (
                       <option key={item.AreaId} value={item.AreaId}>
                         {item.NombreArea}
                       </option>
                      );
                  })}
               </select>
            </div>

            <div className="mt-4">
               <label>Módulo</label>
               <select id="modulo" name="modulo" value={moduloId||0} onChange={(e) => setModuloId(Number(e.target.value))} label="Modulo">
               <option value={0} disabled>
                    Seleccionar un Modulo...
                  </option>
                  {modulos.map((item) => {
                     return (
                       <option key={item.ModuloId} value={item.ModuloId}>
                         {item.NombreMod}
                       </option>
                      );
                  })}
               </select>
               <div className="flex w-full gap-4 mt-6 justify-end">
                 <button name="Aceptar" className="btnprimary" onClick={handleLogin} disabled={habilita} type="button">Aceptar</button>
                 <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
               </div>
            </div>
         </form>
         </div>
     </Modal>
    
    </>
  );
}
WorkPlaces.propTypes = {
  show: PropTypes.bool.isRequired,
  handleshow: PropTypes.func.isRequired,
  
};

export default WorkPlaces;
